import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Wordmark } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Parola en az 6 karakter olmalı"); return; }
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Hesap oluşturuldu");
      nav("/karsilama");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Kayıt başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background">
      <div className="hidden md:flex relative acas-grid p-12 flex-col justify-between border-r border-border/60">
        <Wordmark size="sm" showTagline />
        <div>
          <div className="acas-eyebrow mb-3">Ücretsiz Kayıt</div>
          <h1 className="text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
            Potansiyel müşterileriniz <span className="text-accent">sizi bekliyor.</span>
          </h1>
          <p className="mt-6 text-muted-foreground max-w-md leading-relaxed">
            10 dakikadan kısa sürede işletmenize özel bir AI iş geliştirme çalışanı kurun.
          </p>

          <ul className="mt-8 space-y-3 text-sm">
            {["Otonom AI ajanlarıyla sürekli tarama", "Uyum skoru ve öncelik önerileri", "Türkçe içgörüler ve raporlar"].map((t) => (
              <li key={t} className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-primary" /> {t}
              </li>
            ))}
          </ul>
        </div>
        <div className="text-xs text-muted-foreground">© 2026 Next io</div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-sm acas-fade-up">
          <div className="acas-eyebrow mb-2">Kayıt Ol</div>
          <h2 className="text-3xl font-bold tracking-tight mb-1">Hesap oluşturun</h2>
          <p className="text-sm text-muted-foreground mb-8">AI müşteri kazanım motorunuzu kurmaya başlayın</p>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label htmlFor="name">Ad Soyad</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)}
                     data-testid="register-name" placeholder="Ayşe Yılmaz" className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="email">E-posta</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                     data-testid="register-email" placeholder="siz@sirket.com" className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Parola</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                     data-testid="register-password" placeholder="En az 6 karakter" className="mt-1.5" />
            </div>

            <Button type="submit" disabled={busy} className="w-full gap-2" data-testid="register-submit">
              {busy ? "Oluşturuluyor…" : "Hesabı oluştur"} <ArrowRight size={16} />
            </Button>
          </form>

          <div className="mt-8 pt-6 border-t border-border/60 text-sm text-muted-foreground">
            Zaten hesabınız var mı?{" "}
            <Link to="/giris" className="text-primary font-semibold hover:underline" data-testid="login-link">
              Giriş yapın
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
